import { AsgardCommandBase } from '../command-base';
import { PdfAnnotationActions } from 'src/app/core/pdf-utils/enums';
import { AsgardDocPdf } from 'src/app/core/documents/asgard-doc-pdf';
import { Core } from '@pdftron/webviewer';


export class AnnotationCommand extends AsgardCommandBase {
    constructor(
        public doc: AsgardDocPdf,
        public action: PdfAnnotationActions,
        public annots: Core.Annotations.Annotation[],
        private prevValue?: Core.Annotations.Annotation[] | null,
    ) {
        super(doc);
    }

    async execute() {
        switch (this.action) {
            case PdfAnnotationActions.Added:
                return await this.doc.rawAddAnnotations(this.annots);
            case PdfAnnotationActions.Deleted:
                return await this.doc.rawDeleteAnnotations(this.annots);
            case PdfAnnotationActions.Modified:
                if (this.prevValue && this.prevValue.length !== 0) {
                    await this.doc.rawDeleteAnnotations(this.prevValue);
                }
                return await this.doc.rawAddAnnotations(this.annots);
        }
    }

    async undo() {
        switch (this.action) {
            case PdfAnnotationActions.Added:
                return await this.doc.rawDeleteAnnotations(this.annots);
            case PdfAnnotationActions.Deleted:
                return await this.doc.rawAddAnnotations(this.annots);
            case PdfAnnotationActions.Modified:
                await this.doc.rawDeleteAnnotations(this.annots);
                if (this.prevValue && this.prevValue.length !== 0) {
                    return await this.doc.rawAddAnnotations(this.prevValue);
                }
        }
    }
}
